import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
// import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

import moment from 'moment'
import { Box, Stack, IconButton, Grid } from '@mui/material'

import { ReactComponent as DeleteIcon } from '@/assets/trash_bin.svg'

import FormItem from '@/shared/FormCreator/FormItem'
import combineDateTime from '../../libs/utils/combineDateTime'

const mapStateToProps = () => ({})

const btnProps = {
  size: 'small',
  sx: { borderRadius: 2, padding: 0, color: theme => theme.palette.secondary_80.main },
}

const inputConfig = {
  inputBaseProps: {
    alignItems: 'center',
    childrenSx: {
      '& .MuiOutlinedInput-root': {
        background: 'white',
      },
    },
  },
}

const SendingTime = ({ field, onDelete, onChange, eventStart, eventEnd, disabled }) => {
  // const { t } = useTranslation()
  // const [duringTime, setDuringTime] = useState(null)
  const [limitDate, setLimitDate] = useState(moment().startOf('date'))
  const [maximumDate, setMaximumDate] = useState(moment().startOf('date'))
  // const [limitTime, setLimitTime] = useState(moment().startOf('minutes'))
  // const [maximumTime, setMaximumTime] = useState(moment().startOf('minutes'))

  const {
    control,
    watch,
    setValue,
    // formState: { errors },
  } = useForm({})

  const childDate = watch('childrenStartDate')
  const childTime = watch('childrenStartTime')

  // useEffect(() => {
  // // 組合時間
  // // const time = combineDateTime(childDate, childTime);

  // // 設置日期範圍
  // const startOfEvent = moment(eventStart).startOf('date');
  // const endOfEvent = moment(eventEnd).startOf('date');

  // setLimitDate(startOfEvent);
  // setMaximumDate(endOfEvent);

  // // 設置時間範圍（如果需要）
  // // setLimitTime(moment(eventStart).startOf('minutes'));
  // // setMaximumTime(moment(eventEnd).startOf('minutes'));

  // // if (moment(eventEnd).startOf('minutes').isAfter(moment(time).startOf('minutes'))) {
  // //   setDuringTime(false)
  // // } else {
  // //   setDuringTime(true)
  // // }

  // }, [eventStart, eventEnd, childDate, childTime]);

  // // when user change sending time will check in event start time and end time
  // useEffect(() => {
  //   const time = combineDateTime(childDate, childTime)

  //   onChange(field, { dateTime: time })

  //   // add next line to close esline validate that output waring "React Hook useEffect has a missing dependency" onChange method then loop to re-renden my React page
  //   // eslint-disable-next-line
  // }, [childDate, childTime])

  // // when sending time model change disable or enable that do delete other times or do set new time
  // useEffect(() => {
  //   if (disabled === false) {
  //     const time = combineDateTime(childDate, childTime)
  //     // const time = combineDateTime(moment().toDate(), moment().add(15, 'minutes').toDate())
  //     if (
  //       moment(time)
  //         .startOf('minutes')
  //         .isBefore(moment(eventStart).add(1, 'minutes').startOf('minutes'))
  //     ) {
  //       onChange(field, { dateTime: time })
  //       setValue('childrenStartDate', moment(eventStart).toDate())
  //       setValue('childrenStartTime', moment(eventStart).add(1, 'minutes').toDate())
  //     }
  //     if (
  //       moment(time).startOf('minutes').isAfter(moment(eventEnd).startOf('minutes'))
  //     ) {
  //       onChange(field, { dateTime: time })
  //       setValue('childrenStartDate', moment(eventEnd).toDate())
  //       setValue('childrenStartTime', moment(eventEnd).subtract(1, 'minutes').toDate())
  //     }
  //   } else {
  //     onDelete(field, true)
  //   }

  //   // add next line to close esline validate that output waring "React Hook useEffect has a missing dependency" onDelete, onChange, setValue method then loop to re-renden my React page
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [field, disabled, eventStart, eventEnd, childDate, childTime])

  useEffect(() => {
    // 組合日期和時間
    const time = combineDateTime(childDate, childTime)
    onChange(field, { dateTime: time })

    // 設置事件的開始和結束日期
    const startOfEvent = moment(eventStart).startOf('date')
    const endOfEvent = moment(eventEnd).startOf('date')

    setLimitDate(startOfEvent)
    setMaximumDate(endOfEvent)

    const isBefore = moment(eventStart)
      .startOf('minute')
      .isBefore(moment(eventEnd).startOf('minute'))

    if (disabled === false && isBefore) {
      // 根據條件調整時間
      if (
        moment(time)
          .startOf('minutes')
          .isBefore(moment(eventStart).add(1, 'minutes').startOf('minutes'))
      ) {
        onChange(field, { dateTime: time })
        setValue('childrenStartDate', moment(eventStart).toDate())
        setValue('childrenStartTime', moment(eventStart).add(1, 'minutes').toDate())
      }
      if (moment(time).startOf('minutes').isAfter(moment(eventEnd).startOf('minutes'))) {
        onChange(field, { dateTime: time })
        setValue('childrenStartDate', moment(eventEnd).toDate())
        setValue('childrenStartTime', moment(eventEnd).subtract(1, 'minutes').toDate())
      }
    }
    if (disabled === true) {
      // 清除所有新增時間
      onDelete(field, true)
    }

    // 關閉 eslint 的依賴檢查警告，避免重複渲染問題
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventStart, eventEnd, childDate, childTime, field, disabled])

  return (
    <Box>
      <Grid marginLeft={2}>
        <Grid>
          <Stack direction={'row'} spacing={2} alignItems={'center'}>
            <IconButton
              disabled={disabled}
              {...btnProps}
              size="small"
              paddingleft={2}
              sx={{ color: '#2D2D6C' }}
              onClick={() => {
                onDelete(field, false)
              }}
            >
              <DeleteIcon />
            </IconButton>

            <FormItem
              disabled={disabled}
              defaultValue={moment().startOf('day').toDate()}
              name="childrenStartDate"
              type="date"
              control={control}
              dateprops={{ mindate: limitDate, maxdate: maximumDate }}
              inputConfig={{
                ...inputConfig,
                sx: {
                  width: 180,
                  '& .MuiFormHelperText-root.Mui-error': {
                    wordBreak: 'keep-all',
                    whiteSpace: 'nowrap',
                  },
                },
              }}
              // errors={{
              //   childrenStartDate: duringTime && !disabled
              //     ? { message: t('errors.time_not_between_event_start_and_end_time') }
              //     : ''
              // }}
            />

            <FormItem
              disabled={disabled}
              defaultValue={moment().add('15', 'minutes')}
              name="childrenStartTime"
              type="time"
              control={control}
              // timeprops={{minTime:limitTime, maxTime:maximumTime}}
              inputConfig={{
                ...inputConfig,
                sx: { width: 160 },
              }}
              // errors={{
              //   childrenStartTime: duringTime && !disabled
              //     ? true : undefined
              // }}
            />
          </Stack>
        </Grid>
        {/* <Grid>
          {duringTime && !disabled && (
            <Alert severity="error">{t('errors.time_not_between_event_start_and_end_time')}</Alert>
          )}
        </Grid> */}
      </Grid>
    </Box>
  )
}
export default connect(mapStateToProps)(SendingTime)
